var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "web-button__icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6218 10.393C15.4176 7.68814 11.0056 5.27698 6.41895 3.17563C5.2187 2.62613 3.84657 3.42669 3.75592 4.73412C3.58877 7.13391 3.5 9.55454 3.5 11.996C3.5 14.4403 3.58782 16.8638 3.75592 19.2655C3.84752 20.5729 5.21964 21.3744 6.41895 20.824C11.0056 18.7226 15.4176 16.3105 19.6218 13.6066C20.7927 12.8534 20.7927 11.1462 19.6218 10.393Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay2);
export default __webpack_public_path__ + "static/media/play2.6c897f5079effa80c73b830f8e479cd0.svg";
export { ForwardRef as ReactComponent };